import {Component} from '@angular/core';
import {LoadingService} from '../services/loading.service';

@Component({
  styleUrls: ['./statistics.component.scss'],
  templateUrl: './statistics.component.html'
})
export class StatisticsComponent {
  public reportUrl: string;

  constructor(private loadingService: LoadingService) {
    this.loadingService.hide();
    this.reportUrl = 'https://datastudio.google.com/reporting/ef105f62-3897-499e-982b-2d4692cdc941';
  }
}
